export default __webpack_public_path__ + "static/media/doc-bag.b42247e4.svg";